<template lang="pug">
.keyword-search
  nav.types
    label.type(
      v-for="nav in types",
      :class="{ active: type === nav.key }",
      :key="nav.key",
      @click.prevent="type = nav.key"
    ) {{ nav.name }}
  Component(:is="activeComponent")
</template>

<script>
import ReportItem from './ReportItem'
import EventItem from './EventItem'
import SearchChartItem from './SearchChartItem/SearchChartItem.vue'
export default {
  name: 'KeywordSearch',
  components: {
    ReportItem,
    EventItem,
    SearchChartItem
  },
  data () {
    return {
      type: '危机',
      types: [
        {
          key: '危机',
          name: '危机',
          component: EventItem
        },
        {
          key: '报告',
          name: '报告',
          component: ReportItem
        }
        // {
        //   key: '图谱',
        //   name: '图谱',
        //   component: SearchChartItem
        // }
      ]
    }
  },
  computed: {
    activeComponent () {
      return this.types.find(d => d.key === this.type).component
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.keyword-search {
  height: 100%;
  background-color: #fff;
  border-radius: 4px;
  padding: 24px;

  nav.types {
    display: flex;
    align-items: center;
    font-size: 12px;

    label.type {
      padding: 4px 13px;
      background-color: #fff;
      color: #333;
      border-radius: 13px;
      cursor: pointer;

      &.active {
        color: #3989cb;
        background-color: #ebf3fa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/KeywordSearch.vue